export default __webpack_public_path__ + "static/media/2.7f298e27.jpg";